module.exports = __webpack_public_path__ + "static/media/neon.5158eaf4.png";